import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DossierState, FetchDossierResponse } from './types'
import { deleteDossier, fetchActiveDossier } from './dossierThunks'
import {
  CaseDossier,
  DossierProgression,
  DossierTypeEnum,
} from '../../shared/types'

const initialState: DossierState = {
  data: null,
  loading: false,
  error: null,
}

const dossierSlice = createSlice({
  name: 'dossier',
  initialState,
  reducers: {
    resetDossier(state) {
      state.data = null
      state.loading = false
      state.error = null
    },
    setDossierProgress(state, action: PayloadAction<DossierProgression>) {
      // update dossier case progress
      const { newChapterId, caseComplete } = action.payload || {}
      console.log('*** UPDATED PROGRESS ***', action.payload)
      const caseDossier = state.data as CaseDossier
      // update activeChapterId
      if (newChapterId && newChapterId !== caseDossier.activeChapterId)
        caseDossier.activeChapterId = newChapterId
      // update caseComplete
      if (caseComplete) caseDossier.caseComplete = true
    },
    setDossierDiscoveredIds(state, action) {
      const caseDossier = state.data as CaseDossier
      if (action.payload) caseDossier.discoveredIds = action.payload || []
    },
    clearDossierProgress(state) {
      // clear dossier case progress
      const caseDossier = state.data as CaseDossier
      caseDossier.progress = undefined
    },
  },
  extraReducers: (builder) => {
    builder
      // DELETE DOSSIER
      .addCase(deleteDossier.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(deleteDossier.fulfilled, (state) => {
        state.loading = false
        state.data = null
      })
      .addCase(deleteDossier.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
      // FETCH ACTIVE DOSSIER
      .addCase(fetchActiveDossier.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        fetchActiveDossier.fulfilled,
        (state, action: PayloadAction<FetchDossierResponse>) => {
          state.loading = false
          state.data = action.payload
        }
      )
      .addCase(fetchActiveDossier.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload as string
      })
  },
})

export const {
  resetDossier,
  setDossierProgress,
  setDossierDiscoveredIds,
  clearDossierProgress,
} = dossierSlice.actions
export default dossierSlice.reducer
